export const FETCH_RECIEVED_FOOD_REQUESTS = 'fetch_recieved_food_requests';
export const FETCH_RECIEVED_FOOD_REQUESTS_SUCCESS =
  'fetch_recieved_food_requests_success';
export const FETCH_RECIEVED_FOOD_REQUESTS_FAILURE =
  'fetch_recieved_food_requests_failure';
